import { APIService } from '@services/api/common-services';
import { UseMutateFunction, useMutation } from '@tanstack/react-query';
import { RBDMMeetingDetails } from '.';
import { APICONFIG } from '@config/api.config';

interface IRBDMMeetingDetails {
	mutate: UseMutateFunction<RBDMMeetingDetails, Error, RBDMMeetingDetails, unknown>;
	error: Error | null;
	isError: boolean;
	isPending: boolean;
}

export const useRBDMMeetingMutation = (): IRBDMMeetingDetails => {
	const postRBDMMeetingData = async (meetingFormData: RBDMMeetingDetails): Promise<RBDMMeetingDetails> => {
		const url = `${APICONFIG.MEETINGS_DETAILS_RBDM_ADD}/`;
		return await APIService.postData<RBDMMeetingDetails>(url, meetingFormData);
	};

	const { mutate, error, isError, isPending } = useMutation({
		mutationFn: postRBDMMeetingData,
	});

	return {
		mutate,
		error,
		isError,
		isPending,
	};
};
